module.exports = __webpack_public_path__ + "img/secondary_2x1_z16.b06a5a8e.svg";